import React from "react";
import { forwardRefAs, Generic } from "../../base";
export const TableHeading = forwardRefAs((props, ref) => React.createElement(Generic, Object.assign({ ref: ref }, props)), { as: "th" });
TableHeading.displayName = "Table.Heading";
//# sourceMappingURL=table-heading.js.map